import * as q from "@rei/breakpoint-detector";
import { getUser as O } from "@rei/session";
import A from "@rei/server-prop";
import S from "js-cookie";
const u = (e) => {
  const { config: t, eventLog: n, errors: i } = window.metrics, { eventType: o = "", level: s, message: r } = e, a = () => ["view", "link", "event", "click"].includes(o);
  return s === "error" && i.push(e), a() && n.push(e), t.logToConsole && r ? console.log(`[Analytics ${s}] ${r}`) : t.logToConsole ? console.log(`[Analytics ${o}]`, e) : !1;
}, Q = (e, t) => {
  const n = new Promise((i, o) => {
    setTimeout(() => o(new Error(`Timed out after ${e} ms.`)), e);
  });
  return Promise.race([t, n]);
}, U = () => window.navigator.globalPrivacyControl ? "true" : "false";
function z() {
  const e = [], t = document.cookie ? document.cookie.split("; ") : [];
  let n = [];
  return t.length && (n = t.filter((i) => i.match(/^akaas_(.+)=/))), n.forEach((i) => {
    var l, p, f;
    const o = i.split("="), s = o[0].split("akaas_")[1], r = (l = o.slice(1)) == null ? void 0 : l.join("="), a = (p = r == null ? void 0 : r.split("rn=")) != null ? p : [];
    let c = "";
    (f = a[1]) != null && f.length && (c = decodeURIComponent(a[1]), e.push(`${s}:${c}`));
  }), e;
}
function B() {
  const e = [], t = document.querySelector("#ew-analytics");
  try {
    const { ewExperiences: n } = t ? JSON.parse(t.innerHTML) : [];
    n != null && n.length && n.forEach((i) => {
      e.push(`${i.ewExperience.replace(":", " ")}:${i.ewVariant.replace(":", " ")}`);
    });
  } catch (n) {
    return u({
      level: "warn",
      message: `Could not get Edgeworker experiences: ${n}`
    }), [];
  }
  return e;
}
function G() {
  const e = B(), t = z(), n = [...e, ...t];
  return n.length ? {
    akamaiExperiences: n.join(",")
  } : {};
}
const K = ["siteId", "templateType"], H = ["linkName", "pageName"], h = ":", m = "_", W = {
  view: K,
  link: H
}, w = {
  env: "qa",
  profile: "main",
  noview: !0,
  logToConsole: !0,
  autoClickListeners: !1
}, E = {
  www: "prod",
  localhost: "LocalDev"
}, T = {
  blog: "blog",
  used: "microsites"
}, J = /;+$/, I = (e) => {
  const t = /\||;/g;
  return typeof e == "string" && (e.includes("|") || e.includes(";")) ? e.replace(t, " ") : e;
}, Y = (e, t) => {
  let n = "";
  return e.forEach((i, o, s) => {
    const a = o === s.length - 1 ? ";" : "|";
    if (typeof i == "string")
      t === "evars" && u({
        level: "warn",
        message: `evar '${i}' must have a value. Ex: ${i}=value`
      }), n += `${i}${a}`;
    else {
      const [[c, l]] = Object.entries(i), p = I(c), f = I(l);
      n += `${p}=${f}${a}`;
    }
  }), n;
}, X = (e) => {
  if (!e.productStyle)
    return u({
      level: "warn",
      message: "`productStyle` is a required field"
    });
  const {
    productStyle: t,
    productQty: n,
    productPrice: i,
    events: o,
    evars: s
  } = e, r = /* @__PURE__ */ new Map();
  r.set("events", o), r.set("evars", s);
  const a = n ? n + ";" : ";", c = i ? i + ";" : ";";
  let l = `;${t};${a}${c}`;
  return (o || s) && r.forEach((p, f) => {
    if (p === void 0) {
      l += ";";
      return;
    }
    const y = Y(
      p,
      f
    );
    l += `${y}`;
  }), l = l.replace(J, ""), l;
}, Z = (e) => typeof e == "string" ? e : Array.isArray(e) ? e.map((n) => X(n)).join(",") : "", ee = (e) => typeof e != "string" ? null : e.split(",").map((s) => s.split(";").filter((r) => r !== "")).map((s) => s[0]).join(","), te = (e) => {
  var t, n, i, o, s, r;
  return !((n = (t = window.metrics) == null ? void 0 : t.errors) != null && n.length) && ((o = (i = window.metrics) == null ? void 0 : i.config) == null ? void 0 : o.noview) || !((r = (s = window.metrics) == null ? void 0 : s.config) != null && r.noview) && e();
}, ne = (e) => {
  const t = { siteId: "", templateType: "" };
  if (!e) return t;
  const n = e.includes(h);
  if (!(!!e && !!n)) return t;
  const o = e.split(h), [s] = o;
  let [, r] = o;
  if (r.includes(m)) {
    const c = r.split(
      m
    );
    [r] = c;
    const [, l] = c;
    t.pageSection = l;
  }
  return t.siteId = s, t.templateType = r, t;
}, ie = (e) => {
  if (typeof e != "object") return "";
  const { siteId: t, templateType: n, pageSection: i = null } = e;
  if (!t || !n) return "";
  let o = `${t}:${n}`;
  return i && (o += `${m}${i}`), o;
}, oe = (e) => Object.fromEntries(
  Object.entries(e).filter((t) => t[1] !== null && t[1] !== "")
), N = async (e) => {
  if (e) {
    const t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", t);
    return Array.from(new Uint8Array(n)).map((o) => o.toString(16).padStart(2, "0")).join("");
  }
  return null;
}, se = async () => {
  var e, t, n, i, o, s, r;
  if (window.reiSession) {
    const a = await Q(3e3, O()).catch((f) => (u({
      level: "warn",
      message: `Could not get user from session: ${f}`
    }), !1));
    if (!a) return {};
    const c = (n = (t = (e = a == null ? void 0 : a.contact) == null ? void 0 : e.email) == null ? void 0 : t.trim()) != null ? n : null, l = await N((i = c == null ? void 0 : c.toLowerCase()) != null ? i : null), p = await N((o = c == null ? void 0 : c.toUpperCase()) != null ? o : null);
    return {
      isLoggedIn: a != null && a.isLoggedIn ? "logged in" : "not logged in",
      onlineAccountNumber: a != null && a.isLoggedIn ? a.accountId : null,
      customerMemberStatus: a != null && a.membership ? "member" : "non-member",
      memberNumber: (r = (s = a == null ? void 0 : a.membership) == null ? void 0 : s.memberNumber) != null ? r : null,
      preferredStore: a == null ? void 0 : a.preferredStore,
      hasGPC: U(),
      hashedEmail: l,
      hashedUpperCaseEmail: p
    };
  }
  return {};
}, $ = async (e, t) => {
  var k;
  const n = q.getWindowSize(), i = t(), o = await se(), s = G(), {
    siteId: r,
    pageName: a,
    pageSection: c,
    products: l,
    productSkus: p,
    productStyles: f,
    templateType: y
  } = e || {}, {
    siteId: j,
    pageName: C,
    pageSection: F,
    productSkus: V,
    productStyles: M,
    templateType: R
  } = (k = window == null ? void 0 : window.utag_data) != null ? k : {};
  let g = {
    currentBreakpoint: n,
    siteId: r || j || null,
    pageName: a || C || null,
    pageSection: c || F || null,
    products: l ? Z(l) : null,
    productSkus: p || V || null,
    productStyles: f || M || null,
    templateType: y || R || null,
    ...o,
    ...s
  };
  if (g.pageName) {
    const v = ne(g.pageName);
    g.siteId = g.siteId || v.siteId || null, g.pageSection = g.pageSection || v.pageSection || null, g.templateType = g.templateType || v.templateType || null;
  } else
    g.pageName = ie(g);
  return g.products && !g.productStyles && (g.productStyles = ee(
    g.products
  )), g = oe(g), window.utag_data = {
    ...window.utag_data,
    ...i,
    ...e,
    ...g
  }, window.utag_data;
}, re = (e) => {
  let t = "";
  return typeof e == "object" ? t = e.linkName || "" : typeof e == "string" && (t = e), t;
}, D = (e) => {
  var a;
  let t = "";
  const n = re(e);
  let i = e.siteId || ((a = window == null ? void 0 : window.utag_data) == null ? void 0 : a.siteId) || "", o = h;
  const s = /^[^:]+:.*/, r = /^ct_.*/;
  return e.patternFunction && typeof e.patternFunction == "function" ? t = e.patternFunction(e) : n.match(r) ? i = "" : !n.match(s) && !n.match(r) && (typeof e.contentSection != "undefined" && (i = e.contentSection, o = m, typeof e.verticalPosition != "undefined" && (i = `ct_${e.verticalPosition}_${i}`)), t = i && i.length > 0 ? `${i}${o}` : ""), t += n, t;
}, ae = (e) => {
  var i;
  let t = {};
  e !== null && typeof e == "object" ? (t = e, t.linkName = D(t)) : e !== null && typeof e == "string" ? t.linkName = D({ linkName: e }) : u({
    level: "error",
    message: "No valid linkName provided"
  });
  const { pageName: n } = (i = window == null ? void 0 : window.utag_data) != null ? i : {};
  return t.pageName = t.pageName || n, t;
}, b = (e, t) => {
  const n = Object.keys(t != null ? t : {}), i = (s) => n.includes(s) ? !0 : (u({
    level: "error",
    message: `Data Layer incomplete: ${s} is a required field.`
  }), !1);
  return W[e].every(i);
}, L = (e) => b("view", e) || !1, ce = (e) => b("link", e) || !1, _ = () => window.utag ? window.utag_data ? !0 : (u({
  level: "error",
  message: "Data layer not defined"
}), !1) : (u({
  level: "error",
  message: "Tealium not loaded"
}), !1);
function x() {
  return new A("page-meta-data").get();
}
const le = (e = "") => {
  if (e)
    return e;
  const { pathname: t } = document.location, n = Object.keys(T).find((i) => t.startsWith(i, 1));
  return n ? T[n] : w.profile;
}, ue = () => window.navigator.userAgent.includes("LR_REI_PERF_") || window._DATADOG_SYNTHETICS_BROWSER !== void 0 || S.get("datadog-synthetics-public-id") !== void 0 || S.get("datadog-synthetics-result-id") !== void 0, de = () => new A("page-meta-data").get() || {}, ge = (e = "") => {
  let t;
  if (e && (e === "qa" || e === "prod"))
    t = e;
  else {
    const n = document.location.hostname.split(".")[0];
    E[n] ? t = E[n] : t = w.env;
  }
  return t;
}, pe = (e) => {
  const t = e;
  t && Object.keys(w).forEach((n) => {
    const i = n;
    n in t && (typeof t[i] == "boolean" || t[i].length > 0) && (window.metrics.config[n] = t[i], delete t[i]);
  }), window.metrics.config.env = ge(window.metrics.config.env), window.metrics.config.profile = le(window.metrics.config.profile), window.metrics.config = Object.assign(w, window.metrics.config), window.utag_cfg_ovrd = {
    noview: window.metrics.config.noview
  };
}, fe = async (...e) => {
  var t, n;
  Object.assign((t = window == null ? void 0 : window.utag_data) != null ? t : {}, ...e), !window.metrics.viewQueue.length && await $((n = window == null ? void 0 : window.utag_data) != null ? n : {}, x);
}, me = (e) => {
  try {
    (function(t, n, i, o, s, r) {
      i = "https://tags.tiqcdn.com/utag/rei/" + n + "/" + t + "/utag.js", o = document, s = "script", r = o.createElement(s), r.onload = e, r.src = i, r.type = "text/java" + s, r.async = !0, i = o.getElementsByTagName(s)[0], i.parentNode.insertBefore(r, i);
    })(window.metrics.config.env, window.metrics.config.profile);
  } catch (t) {
    return u({
      level: "error",
      message: `Error adding Tealium script: ${t}`
    }), !1;
  }
  return !0;
}, we = () => {
  window.metrics.linkQueue && window.metrics.linkQueue.length > 0 && window.metrics.linkQueue.forEach((t) => {
    const {
      eventType: n,
      processed: i,
      callback: o,
      data: s
    } = t;
    ["link", "click", "event"].includes(n) && !i && (window.metrics.link(s, o, n), t.processed = !0);
  });
}, ye = () => {
  window.metrics.viewQueue && window.metrics.viewQueue.length > 0 && window.metrics.viewQueue.forEach((t) => {
    const {
      eventType: n,
      processed: i,
      data: o,
      callback: s
    } = t;
    n === "view" && !i && (window.metrics.view(o, s), t.processed = !0);
  });
}, ve = async (e, t) => {
  const n = e, i = window.utag_data || {}, o = de();
  window.utag_data = {}, await fe(o, i, n);
  const s = () => {
    u({
      level: "info",
      message: "Initialized."
    }), window.metrics.config.noview === !1 && (u({
      event: "view",
      data: (window == null ? void 0 : window.utag_data) || {}
    }), window.metrics.pageViewSent = !0), ye(), typeof t == "function" && t();
  };
  !ue() && te(() => L(window.utag_data)) ? (me(s), window.metrics.config.autoClickListeners && window.metrics.addClickListenersFromSelector(), window.metrics.listenerAlgonomyData()) : u({
    level: "info",
    message: "Skipped injecting Tealium script. If not expected confirm required data is provided."
  }), window.metrics.initialized = !0, window.metrics.initializing = !1;
}, he = (e) => {
  var t;
  return (e == null ? void 0 : e.dataset) && ((t = e == null ? void 0 : e.dataset) == null ? void 0 : t.analyticsId);
}, P = (e) => {
  const t = e == null ? void 0 : e.closest("[data-location-index]");
  return t || (e == null ? void 0 : e.closest("[data-location-name]"));
}, ke = (e) => {
  var o, s;
  const t = [];
  let n = "", i = P(e.parentNode);
  for (; i; )
    (o = i.dataset) != null && o.locationName && t.unshift(i.dataset.locationName), (s = i.dataset) != null && s.locationIndex && !n && (n = i.dataset.locationIndex), i = P(i.parentNode);
  return {
    locationNames: t.join("_"),
    locationIndex: n
  };
}, Se = (e) => {
  const t = e.querySelector("img");
  return t ? t.getAttribute("alt") : "";
}, Ee = (e) => `${e.dataset.analyticsId || e.textContent || Se(e)}`.trim() || "undefined", Te = (e) => {
  const t = e.closest("a, button");
  return t || !1;
}, Ie = (e) => {
  var l;
  const t = e.target;
  if (t.closest(`
  [data-analytics-config="exclude"] > a,
  [data-analytics-config="exclude"] > button,
  [data-analytics-config="exclude-all"] a,
  [data-analytics-config="exclude-all"] button`)) return;
  const i = Te(t);
  if (!i) return;
  const o = {
    linkName: (l = he(i)) != null ? l : Ee(i)
  }, { locationNames: s, locationIndex: r } = ke(t), [a, c] = s.split("_");
  s && a === "ct" && Number.isInteger(parseInt(c, 10)) && (o.linkName = `${s}_${o.linkName}`, o.verticalPosition = c), o.linkName && t.tagName === "A" && t.href && (o.destinationUrl = t.href), r && Number.isInteger(parseInt(r, 10)) && (o.horizontalPosition = r), window.metrics.link(o, e);
}, Ne = {
  data() {
    return {
      defaultAnalyticsViewData: {
        siteId: "rei"
        // optional override in the component with the analyticsViewData() computed value
      }
    };
  },
  computed: {
    analyticsMap() {
      if (!this.renderingMap) return {};
      let e = 1;
      return Object.keys(this.renderingMap).reduce(
        (t, n) => (this.renderingMap[n] && (t[n] = `ct_${e}_${n}`, e += 1), t),
        {}
      );
    }
  },
  mounted() {
    window && window.metrics && (window.metrics.addClickListenersFromSelector(), window.metrics.view(
      {
        ...this.defaultAnalyticsViewData,
        ...this.analyticsViewData
      }
    ));
  }
};
function De() {
  return new Promise((e) => {
    setTimeout(e, 0);
  });
}
const _e = (e) => {
  const t = ["message", "placementName", "strategy"];
  return e.map((n, i) => {
    const o = {
      rrPlacementIndex: i.toString()
    };
    return Object.keys(n).forEach((s) => {
      if (t.includes(s) && n[s] !== void 0) {
        const r = `rr${s.charAt(0).toUpperCase()}${s.slice(1)}`;
        o[r] = n[s];
      } else
        o[s] = n[s];
    }), o;
  });
}, d = {
  version: "4.10.3",
  errors: [],
  config: {},
  eventLog: [],
  viewQueue: [],
  linkQueue: [],
  pageViewSent: !1,
  pageViewSending: !1,
  initialized: !1,
  initializing: !1,
  mixins: { analyticsMixin: Ne },
  view: async (e, t) => {
    var i, o, s;
    const n = (r = !0) => {
      var a;
      r && u({
        eventType: "view",
        data: e,
        utagData: (a = window == null ? void 0 : window.utag_data) != null ? a : {}
      }), d.pageViewSending = !1, d.pageViewSent = !0, typeof t == "function" && t(), we();
    };
    if (d.pageViewSending = !0, !window.utag || !d.initialized || d.initializing)
      d.viewQueue.push({
        eventType: "view",
        data: e,
        utagData: (i = window == null ? void 0 : window.utag_data) != null ? i : {},
        callback: t
      });
    else
      try {
        await $(e, x), _() && L(window.utag_data) && ((s = (o = window.utag).view) == null || s.call(o, window.utag_data, n));
      } catch (r) {
        u({
          level: "error",
          eventType: "view",
          message: `view event error: ${r}`
        }), n(!1);
      }
  },
  link: async (e, t, n = "link") => {
    var a, c;
    let i;
    typeof e == "string" ? i = e : i = { ...e };
    const o = ae(e), s = {
      eventType: n,
      data: i,
      utagData: { ...window.utag_data, ...o }
    }, r = (l = !0) => {
      l && u(s), typeof t == "function" ? t() : typeof t == "string" && (window.location.href = t);
    };
    if (!d.pageViewSent || d.pageViewSending)
      d.linkQueue.push({
        ...s,
        callback: t
      });
    else
      try {
        _() && ce(o) && (await De(), typeof window.s != "undefined" && !window.s.useBeacon && (window.s.useBeacon = !0), (c = (a = window == null ? void 0 : window.utag) == null ? void 0 : a.link) == null || c.call(a, o, r));
      } catch (l) {
        u({
          level: "error",
          eventType: "link",
          message: `link event error: ${l}`
        }), r(!1);
      }
  },
  /**
   * Legacy click method for backwards compatability, remove after @rei-metrics 3.0 is fully adopted
   * @deprecated Use {@link Metrics.link} instead
   * @param data
   * @param element
   * @param cb
   */
  click: (e, t, n) => {
    if (!e) {
      u({
        level: "error",
        eventType: "click",
        message: "click event data not provided"
      });
      return;
    }
    n && typeof n == "function" ? d.link(e, n, "click") : t && t.href ? d.link(e, t.href, "click") : d.link(e, void 0, "click");
  },
  event: (e, t) => {
    try {
      d.link(e, t, "event");
    } catch (n) {
      u({
        level: "error",
        eventType: "event",
        message: `event error: ${n}`
      }), typeof t == "function" && t();
    }
  },
  /**
   * Retrieves the visitor ID asynchronously.
   * @returns A promise that resolves with the visitor ID.
   * @deprecated This function will be deprecated once all applications migrate to `alloy.js`.
   */
  async getVisitorId() {
    var e;
    if (typeof (window == null ? void 0 : window.alloy) == "function")
      return (await window.alloy("getIdentity")).identity.ECID;
    if ((e = window.visitor) != null && e.getMarketingCloudVisitorID)
      return window.visitor.getMarketingCloudVisitorID();
    throw new Error("Both alloy and visitor are undefined");
  },
  /**
   * Applies click listeners to all <a> and <button> child elements within a given selector
   * (default selector is #app).
   *
   * @param wrapSelector optional selector used to limit where listeners should be added
   * on the pages
   */
  addClickListenersFromSelector: (e = "#app") => {
    e === "#app" && document.querySelectorAll("#app").length > 1 && u({
      level: "error",
      message: 'Multiple elements found with ID "app", and element IDs must be unique! Analytics reporting will be inaccurate.'
    });
    const t = document.querySelectorAll(`${e} > *`);
    Array.from(t).forEach((i) => {
      i.addEventListener("click", Ie);
    });
  },
  init: async (e, t) => {
    if (d.initialized || d.initializing) {
      u({
        level: "info",
        message: "Already initialized, skipping duplicate init"
      });
      return;
    }
    const n = { ...e };
    pe(n), (!e || Object.keys(e).length === 0) && u({
      level: "warn",
      message: "You should probably add some configuration"
    }), u({
      level: "info",
      message: "Page has loaded, initializing now."
    }), d.initializing = !0, await ve(e, t);
  },
  listenerAlgonomyData: () => {
    document.addEventListener("rr-json-data-loaded", (e) => {
      const t = e, n = t.detail, i = JSON.parse(n);
      _e(i == null ? void 0 : i.placements).forEach((s) => {
        s.linkName = t.type, d.event(s);
      });
    });
  }
};
typeof window != "undefined" && (window.metrics = d);
export {
  d as default
};
